import React from "react";
import Modal from "../../Modal/Modal";
import IngestionConfigGridItem from "../../../../types/ingestion/IngestionConfigGridItem";

interface Props {
    onClose: () => void;
    configInfo: IngestionConfigGridItem;
}

class IngestionConfigInfoModal extends React.Component<Props, { isOpen: boolean }> {

    constructor(props: Props) {
        super(props);

        this.state = {
            isOpen: true
        };

        this.close = this.close.bind(this);
    }

    close(): void {
        this.setState({ isOpen: false });
        this.props.onClose();
    }

    render(): JSX.Element {
        return (
            <>
                <Modal state={{ isOpen: this.state.isOpen, title: 'Info', error: '' }} close={this.close} size='medium'>
                    <div className='display-flex width-100-percents'>
                        <label>Created By:</label><label className='margin-left-10px'>{this.props.configInfo.createdBy}</label>
                    </div>
                    <div className='display-flex width-100-percents'>
                        <label>Date Created:</label><label className='margin-left-10px'>{this.props.configInfo.createdTimestamp}</label>
                    </div>
                     <div className='display-flex width-100-percents'>
                        <label>Data:</label><label className='margin-left-10px'>{this.props.configInfo.data}</label>
                    </div>
                </Modal>
            </>
        );
    }
}

export default IngestionConfigInfoModal;